import { render, staticRenderFns } from "./PabauSales.vue?vue&type=template&id=0b12a5e4"
import script from "./PabauSales.vue?vue&type=script&lang=js"
export * from "./PabauSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports